export const DEFAULT_STATE = null;

const activeButton = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case 'ADD_SIGNATURE_SECTION_SHOW':
      return 'sign';
    default:
      return state;
  }
};

export default activeButton;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/SignatureReducer/activeButton.jsx